/**
 * Header Bidding Module
 * Handles all header bidding funcitonality with partners
 * version 2.4.0
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdModules/headerbidding',[
    "jquery",
    "logging",
    "AdBidders/amazon",
    "AdBidders/prebid"
], function ($, logging, amazon, prebid) {
    "use strict";

    var _ModuleName = "Header Bidding Module";
    var _config = {}

    /**
     * Initialize Header Bidding Partners
     * @param {config} config Configuration object to pass to header bidders
     */
    var init = function (config, monitorName) {
        $.extend(_config, config.headerbidding);

        if (_config.enabled) {
            ;

            // init Amazon header bidding
            amazon.init(_config, monitorName);

            // init prebid.js
            prebid.init(_config, monitorName);
        } else {
            ;
        }
    }

    /**
     * Start Header Bidding with Partners
     * @param {Array<AdSlot>} slots List of ad slot objects
     * @param {pageconfig} pageconfig DFP Page config object
     */
    var start = function (slots, pageconfig) {
        if (_config.enabled) {
            ;

            // if amazon is enabled, let's register the ad slots and g et the bidding started
            if (amazon.enabled()) {
                // register ad slots with Amazon header bidding
                amazon.registerAdSlots(slots);

                // Kick off Amazon header bidding processes
                amazon.setNetworkId(pageconfig.hierarchy);
                amazon.start(slots);
            }
            
            // if prebid is enabled, let's register the ad slots and get the bidding started
            if (prebid.enabled()) {
                // register ad slots with prebid header bidding
                prebid.registerAdSlots(slots);

                // Kick off prebid header bidding process
                prebid.start(slots);
            }
        }
    }

    var registerSlots = function (slots) {
        if (_config.enabled) {
            ;

            // register ad slots with Amazon header bidding
            amazon.registerAdSlots(slots);

            prebid.registerAdSlots(slots);
        }
    }

    /**
     * Refresh defined ad slots with header bidding partners
     * @param {Array<AdSlot>} slots List of ad slot objects to be refreshed (if single slot is passed in, it is converted)
     * @param {String} monitor Name of ready monitor
     */
    var refresh = function (slots, monitor) {
        // If a single slot was passed in, convert to array
        if(!Array.isArray(slots)) {
            slots = [ slots ];
        } 

        if (_config.enabled) {
            ;
            amazon.refreshAdSlots(slots, monitor);
            prebid.refreshAdSlots(slots, monitor);
        }
    }

    /**
     * Removes slot from being tracked
     */
    var removeSlot = function (slot) {
        amazon.removeSlot(slot);
        prebid.removeSlot(slot);
    }

    return {
        init: init,
        start: start,
        registerSlots: registerSlots,
        refresh: refresh,
        removeSlot: removeSlot,
        enabled: (function() { return _config.enabled; }),
    }
});
